import React from "react";
import "../Styles/Choose.css";
import "../assets/css/flaticon.css";
import "../assets/css/custom-animation.css";
import development from "../assets/icons/development.png";
// import growth from "../assets/All Images/growth.jpg";
import growth from "../newimgs/Ethos.png";
import team from "../assets/icons/team.png";
import solution from "../assets/icons/solution.png";

const Choose = () => {
  return (
    <div>
      <section className="bd-choose-area fix pb-80">
        <div className="container">
          <div className="bd-choose-shape choose-main-responsive">
            <div className="row">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1">
                <div className="bd-choose-text  chooseArea mb-30 z-index  pt-90 ethosText" >
                  <div className="bd-section-title-wrapper mb-35">
                    {/* <h5 className="bd-section-subtitle first-tittle-respon">
                      We Stand By{" "}
                    </h5> */}
                    <h2 className="bd-section-title mb-25" style={{fontSize:"38px"}}>
                      Our <span style={{ color: "#098FB4",fontFamily:"sans-serif" }}>Company</span> ethos{" "}
                      {/* <span style={{ color: "#098FB4" }}>Growth</span>{" "} */}
                    </h2>
                  </div>
                  <div className="bd-choose-info-wrapper">
                    <div className="bd-choose-info mb-40">
                      {/* <div className="bd-choose-info-icon">
                        <i>
                          <img
                            className="icon"
                            src={solution}
                            style={{ maxWidth: "none" }}
                          />
                        </i>
                      </div> */}
                      <div className="bd-choose-info-text">
                        {/* <h2 className="bd-choose-info-title mb-15">
                          All-in-One Solution
                        </h2> */}
                        <p className="m-0">
                          At the heart of our consulting firm lies a commitment to excellence, where bespoke solutions meet unparalleled expertise.
                        </p><br/>
                          <p className="m-0">
                         Our team of distinguished professionals craft strategies that not
                          only elevate your business but redefine industry standards with a touch of sophistication.
                        </p>
                      </div>
                    </div>
                    {/* <div className="bd-choose-info mb-40">
                      <div className="bd-choose-info-icon">
                        <i>
                          <img
                            src={team}
                            style={{ maxWidth: "none" }}
                          />
                        </i>
                      </div>
                      <div className="bd-choose-info-text ">
                        <h2 className="bd-choose-info-title mb-15">
                          Trustworthy Team
                        </h2>
                        <p className="m-0">
                         Our team of distinguished professionals craft strategies 
                         that not only elevate your business but redefine industry standards with a touch of sophistication
                        </p>
                      </div>
                    </div> */}
                    {/* <div className="bd-choose-info">
                      <div className="bd-choose-info-icon">
                        <i>
                          <img
                            src={development}
                            style={{ maxWidth: "none" }}
                          />
                        </i>
                      </div>
                      <div className="bd-choose-info-text ">
                        <h2 className="bd-choose-info-title mb-15">
                          Strong and Reliable Development Process
                        </h2>
                        <p className="m-0">
                          A strong management team that oversees every project
                          with care, backed by an in-house team of skilled
                          project managers and developers.
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                <div className="bd-choose-img text-end mb-30 z-index">
                  <div className="row align-items-center img_choose-responsive custom-mar-15">
                    {/* <div className="col-xl-6 col-lg-6 col-6 custom-pad-15"> */}
                    <img
                      src={growth}
                      style={{ width: "700px" }}
                    ></img>
                    {/* </div> */}
                  </div>
                  <div className="bd-choose-video-popup"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Choose;
